module.exports = __webpack_public_path__ + "static/img/contract_cabinet_temp.6757a672.png";